export const TOOLTIP_STYLE = {
        fontSize: 12, fontWeight: 'normal', padding: 8, borderRadius: 6,
        fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
        backgroundColor: 'black', color: 'white', zIndex: 999999,
        whiteSpace: 'normal' as const,
};